import ShopifyItemsPage from './ShopifyItemEditor';
import { isServiceProduct } from './AdminShopServices';

export default function AdminProducts() {
  return (
    <ShopifyItemsPage
      title="מוצרים"
      description="עריכת שם, תיאור, מחיר, תמונות ושדות התוכן של עמוד המוצר. השינויים נכתבים ישירות לשופיפיי."
      filter={(p) => !isServiceProduct(p)}
      emptyText="אין מוצרים."
    />
  );
}

